import { Box, styled } from '@mui/material';
import { palette } from '../../theme/palette';
import { HFlex } from '../FlexContainers';

export const BranchContactBox = styled(HFlex)`
  justify-content: space-between;
`;

export const BranchContact = styled(Box)`
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.375px;
  font-weight: 400;
`;

export const BranchContactPhoneNumber = styled('span')`
  color: ${palette.primary.main};
  text-wrap: nowrap;
  text-decoration: none;

  :hover {
    cursor: pointer;
  }
`;

export const TextBold = styled('span')`
  font-weight: 700;
`;
